export default __webpack_public_path__ + "static/media/community-bg-mobile.5bc0c716.png";